<template>
  <div class="about-page">
    <header class="header">
      <el-button text class="back-btn" aria-label="返回" @click="goBack">
        <img src="@/assets/返回.svg" alt="返回" class="back-icon" />
      </el-button>
      <h1 class="title">关于我们</h1>
      <div class="header-right"></div>
    </header>

    <main class="content">
      <el-card class="hero-card" shadow="never">
        <img src="@/assets/logo.png" alt="公司Logo" class="company-logo" />
        <h2 class="company-name">安徽和丰信息化系统</h2>
        <p class="product-name">移动端仓储管理系统（WMS）</p>
        <el-tag type="primary" effect="plain" round>版本 v{{ appVersion }}</el-tag>
      </el-card>

      <el-card class="section-card" shadow="never">
        <template #header>
          <div class="section-header">
            <el-icon color="var(--primary-color)"><OfficeBuilding /></el-icon>
            <span>产品介绍</span>
          </div>
        </template>
        <p class="section-text">
          安徽和丰专注仓储物流信息化，面向制造业与流通业提供移动端 WMS
          解决方案，覆盖入库、出库、库存、备料与盘点等现场作业场景。
        </p>
        <p class="section-text">
          系统支持扫码作业、权限菜单动态配置与多主题设置，帮助一线人员提升作业效率与准确率。
        </p>
      </el-card>

      <el-card class="section-card" shadow="never" :body-style="{ padding: 0 }">
        <template #header>
          <div class="section-header">
            <el-icon color="#38b2ac"><Grid /></el-icon>
            <span>软件功能</span>
          </div>
        </template>
        <div
          v-for="item in features"
          :key="item.title"
          class="feature-item"
        >
          <div class="feature-icon-wrap" :style="{ background: item.bg }">
            <el-icon :size="20" :color="item.color">
              <component :is="item.icon" />
            </el-icon>
          </div>
          <div class="feature-info">
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </el-card>

      <el-card class="section-card" shadow="never" :body-style="{ padding: 0 }">
        <template #header>
          <div class="section-header">
            <el-icon color="#f39c12"><PhoneFilled /></el-icon>
            <span>联系我们</span>
          </div>
        </template>
        <div
          v-for="item in contacts"
          :key="item.label"
          class="contact-item"
        >
          <el-icon class="contact-icon" :color="item.color">
            <component :is="item.icon" />
          </el-icon>
          <div class="contact-body">
            <div class="contact-label">{{ item.label }}</div>
            <div class="contact-text">{{ item.value }}</div>
          </div>
        </div>
      </el-card>

      <p class="copyright">© 2026 安徽和丰信息化系统 版权所有</p>
    </main>
  </div>
</template>

<script>
import { markRaw } from 'vue'
import { useRouter } from 'vue-router'
import {
  OfficeBuilding,
  Grid,
  PhoneFilled,
  Box,
  Van,
  DataAnalysis,
  Tools,
  Histogram,
  Document,
  User,
  Location,
  Iphone,
  Message
} from '@element-plus/icons-vue'

const APP_VERSION = '6.6.01'

export default {
  name: 'AboutUs',
  components: {
    OfficeBuilding,
    Grid,
    PhoneFilled,
    Box,
    Van,
    DataAnalysis,
    Tools,
    Histogram,
    Document,
    User,
    Location,
    Iphone,
    Message
  },
  setup() {
    const router = useRouter()

    const features = [
      {
        title: '入库管理',
        desc: '创单及收货、PLS扫码入库、上架任务、单/多托盘收货与红冲',
        icon: markRaw(Box),
        color: 'var(--primary-color)',
        bg: 'rgba(35, 177, 192, 0.12)'
      },
      {
        title: '出库管理',
        desc: '出库列表、出库单查询、扫码出库、退货出库、装车单与装车扫描',
        icon: markRaw(Van),
        color: '#3b82f6',
        bg: 'rgba(59, 130, 246, 0.12)'
      },
      {
        title: '库存管理',
        desc: '库存/库位查询、移位、良不良转换、调拨、项目组/库位/托盘盘点',
        icon: markRaw(DataAnalysis),
        color: '#10b981',
        bg: 'rgba(16, 185, 129, 0.12)'
      },
      {
        title: '备料管理',
        desc: '备料列表、PLS备料、出库单打印、备料箱码校验',
        icon: markRaw(Tools),
        color: '#f59e0b',
        bg: 'rgba(245, 158, 11, 0.12)'
      },
      {
        title: '基础数据',
        desc: '物料信息查询，支持查看物料图片与基础资料',
        icon: markRaw(Document),
        color: '#8b5cf6',
        bg: 'rgba(139, 92, 246, 0.12)'
      },
      {
        title: '数据看板',
        desc: '仓储运营数据可视化，库位与作业情况一览',
        icon: markRaw(Histogram),
        color: '#ef4444',
        bg: 'rgba(239, 68, 68, 0.12)'
      },
      {
        title: '个人中心',
        desc: '修改密码、系统设置（主题/语言/通知）、版本更新记录、关于我们',
        icon: markRaw(User),
        color: '#64748b',
        bg: 'rgba(100, 116, 139, 0.12)'
      }
    ]

    const contacts = [
      {
        label: '地址',
        value: '安徽省合肥市肥西县',
        icon: markRaw(Location),
        color: 'var(--primary-color)'
      },
      {
        label: '技术支持',
        value: '188-6041-8570',
        icon: markRaw(Iphone),
        color: '#10b981'
      },
      {
        label: 'BUG 反馈邮箱',
        value: '3467272155@qq.com',
        icon: markRaw(Message),
        color: '#f59e0b'
      }
    ]

    const goBack = () => router.back()

    return {
      appVersion: APP_VERSION,
      features,
      contacts,
      goBack
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background: var(--background-color);
  box-sizing: border-box;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  padding-top: calc(12px + env(safe-area-inset-top));
  background: var(--header-background);
  color: var(--header-text);
  box-shadow: 0 2px 8px rgba(35, 177, 192, 0.18);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: calc(52px + env(safe-area-inset-top));
  box-sizing: border-box;
}

.back-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  color: var(--header-text);
}

.back-icon {
  width: 22px;
  height: 22px;
}

.title {
  margin: 0;
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: var(--header-text);
}

.header-right {
  width: 36px;
}

.content {
  padding: 12px;
  margin-top: calc(52px + env(safe-area-inset-top));
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
}

.hero-card,
.section-card {
  margin-bottom: 12px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  background: var(--card-background);
}

.hero-card :deep(.el-card__body) {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 16px;
  text-align: center;
}

.section-card :deep(.el-card__header) {
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-color);
}

.section-card :deep(.el-card__body) {
  padding: 12px 14px;
}

.company-logo {
  width: 72px;
  height: 72px;
  border-radius: 14px;
  object-fit: contain;
  margin-bottom: 12px;
  border: 1px solid var(--border-color);
  background: var(--card-background);
}

.company-name {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.product-name {
  margin: 0 0 10px;
  font-size: 13px;
  color: var(--text-secondary);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.section-text {
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.7;
  color: var(--text-secondary);
}

.section-text:last-child {
  margin-bottom: 0;
}

.feature-item,
.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-color);
}

.feature-item:last-child,
.contact-item:last-child {
  border-bottom: none;
}

.feature-icon-wrap {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-info {
  flex: 1;
  min-width: 0;
}

.feature-info h4 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.feature-info p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.contact-icon {
  flex: 0 0 auto;
  margin-top: 2px;
  font-size: 18px;
}

.contact-body {
  flex: 1;
  min-width: 0;
}

.contact-label {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 2px;
}

.contact-text {
  font-size: 14px;
  color: var(--text-primary);
  word-break: break-all;
}

.copyright {
  margin: 8px 0 0;
  text-align: center;
  font-size: 12px;
  color: var(--text-secondary);
}
</style>
